    <div class="wrapper-themes">
        <div class="section-title row">
            <div class="section-btn">
                <button routerLink='/dashboard/design' class="btn btn-back" [attr.aria-label]="'Back' | translate">
                  <i class="fi-rr-arrow-alt-left"></i>
                </button>
            </div>
            <div>
                <div class="title" [attr.data-parent]="'Storefront' | translate">{{'Themes' | translate}} </div>
            </div>
        </div>

        <div class="section-main">
            <div class="themes-intro">{{ 'Choose a theme for your storefront.' | translate }}</div>

            <div *ngIf="isLoading" class="loading-spinner">
                <mat-spinner class="mx-auto my-5" [diameter]="50"></mat-spinner>
            </div>

            <div *ngIf="!isLoading && themeList.length == 0" class="no-records">{{ 'No Record found' | translate }}</div>

            <!-- Each card opens the theme's preview page; previewThemePreset stores
                 the pick for it before the router navigates. -->
            <div class="theme-grid" *ngIf="!isLoading && themeList.length">
                <ng-container *ngIf="{ id: currentThemeId$ | async } as current">
                    <a class="theme-card" *ngFor="let theme of themeList" [attr.data-theme-id]="theme.preset_id"
                        [class.is-current]="+theme.preset_id === current.id"
                        routerLink="/dashboard/theme-select-page" (click)="previewThemePreset(theme.preset_id)">
                        <div class="theme-card-preview">
                            <img [src]="theme.preview_img" [alt]="theme.preset_name" loading="lazy"
                                (error)="setErrorImg($event, theme.theme_id)" />
                        </div>
                        <div class="theme-card-footer">
                            <span class="theme-card-name">{{ theme.preset_name | translate }}</span>
                            <span class="theme-card-badge" *ngIf="+theme.preset_id === current.id">
                                <i class="fi fi-rr-check"></i>{{ 'Current theme' | translate }}
                            </span>
                        </div>
                    </a>
                </ng-container>
            </div>
        </div>
    </div>

    <ng-template #previewThemeModal let-modal>
        <div class="p-2">
            <div class="row">
                <div class="col">
                    <button type="button" class="close text-primary" (click)="closeModal()"><i
                        class="fas fa-times"></i></button>
                    <h4 class="text-center">{{ previewedTheme.preset_name | translate}}</h4>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <img class="preview-theme-image w-100" [src]="previewedTheme.preview_img">
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #success let-modal>
        <div class="modal-body text-center">
            <div class="row">
                <div class="col pt-4 pt-lg-0">
                    <h4>{{"Successfully Update" | translate}}</h4>
                </div>
            </div>
            <button class="btn btn-primary" type="button" name="button"
                (click)="modal.close('Send click')  ">{{"Close" | translate}}</button>
        </div>
    </ng-template>

    <ng-template #fail let-modal>
        <div class="modal-body text-center">
            <div class="row">
                <div class="col">
                    <h4>{{ errorMsg }}</h4>
                </div>
            </div>
            <button class="btn btn-danger" type="button" name="button"
                (click)="modal.close('Send click')  ">{{'Close' | translate}}</button>
        </div>
    </ng-template>
